import { request } from 'graphql-request';
import getFeaturedArticles from '@/graphql/queries/getFeaturedArticles';
import getConfig from 'next/config';
import getSports from '@/graphql/queries/getSports';
import {
  QueryGetSingleArticleArgs,
  ArticleSearchInput,
  Type,
  PageType,
} from '../graphql/gql/graphql';
import getArticlesQuery from '../graphql/queries/getArticlesQuery';
import getArticleBySlugQuery from '../graphql/queries/getArticleBySlugQuery';
import getAuthorsQuery from '../graphql/queries/getAuthors';
import getMenusQuery from '../graphql/queries/getMenus';
import getShortFormsQuery from '../graphql/queries/getShortForms';
import getActiveFixturesQuery from '../graphql/queries/getActiveFixturesQuery';

const getOrchestrationEndpoint = () => {
  const { publicRuntimeConfig } = getConfig() || {};
  const { ORCHESTRATION_ENDPOINT } = publicRuntimeConfig || {};
  return ORCHESTRATION_ENDPOINT || 'http://localhost:3000/api';
};

export type GraphqlResponse<T, K extends string = string> = {
  data: Record<K, T>;
};

export function getMenus(isPreview?: boolean) {
  return request(
    getOrchestrationEndpoint(),
    getMenusQuery,
    { isPreview },
  );
}

export function getArticleBySlug({
  slug,
  contentStatus,
  isPreview,
}: QueryGetSingleArticleArgs) {
  return request(
    getOrchestrationEndpoint(),
    getArticleBySlugQuery,
    { slug, contentStatus, isPreview },
  );
}

export function getAllArticles({
  limit = 10,
  afterCursor = null,
  sportName = null,
}: ArticleSearchInput) {
  return request(
    getOrchestrationEndpoint(),
    getArticlesQuery,
    {
      filter: {
        limit,
        sportName,
        afterCursor,
      },
    },
  );
}

export function getArticlesBySport(sports: string[]) {
  return Promise.all(sports.map((sportName) => request(
    getOrchestrationEndpoint(),
    getArticlesQuery,
    {
      filter: {
        sportName,
        afterCursor: '',
      },
    },
  )));
}

export function getFeaturedArticlesBySport(sports:string[]) {
  return Promise.all(sports.map((sportName) => request(
    getOrchestrationEndpoint(),
    getFeaturedArticles,
    {
      filter: {
        sportName,
        pageType: sportName ? PageType.Sport : PageType.Homepage,
      },
    },
  )));
}

export function getShortForms(sport: string = 'All', cursor?: string) {
  return request(
    getOrchestrationEndpoint(),
    getShortFormsQuery,
    { sportName: sport === 'All' ? null : sport, cursor },
  );
}

export function getAuthors(contentType: Type, sport: string = 'All', cursor?: string) {
  return request(
    getOrchestrationEndpoint(),
    getAuthorsQuery,
    { contentType, sportName: sport === 'All' ? null : sport, cursor },
  );
}

export function getScores(sport?: string) {
  return request(
    getOrchestrationEndpoint(),
    getActiveFixturesQuery,
    {
      input: {
        sport,
      },
    },
  );
}

export function getAvailableSports(isPreview?: boolean) {
  return request(
    getOrchestrationEndpoint(),
    getSports,
    { isPreview },
  );
}

export default {};
